import { Pipe, PipeTransform } from '@angular/core';
import { CasingGradeTable } from '../models/casing-grade-table.model';
import { ROLES } from '../../authentication/authRoles.constants';

@Pipe({
  name: 'isDeletable',
  pure: true,
  standalone: false
})
export class IsDeletablePipe implements PipeTransform {
  private userRoles: string = localStorage.getItem('roles') || '';

  transform(item: CasingGradeTable): boolean {
    return !item.assignedToCustomer && this.userRoles.includes(ROLES.edit_casing_grade);
  }
}
